import {I18N_VALUE_CODE_KEY, I18N_VALUE_HELP_MESSAGE_KEY} from 'lf-at-theme';
import {ktI18nFn} from '../../../shared';

/**
 * Non-Union form i18n object for the en-US locale.
 */
export const nonUnionFormI18nEnUS: Record<string, any> = {
  '/non-union-form': {
    label: 'Non-Union Scheme - Registration',
    nationalTaxReference: 'Tax Identification Number on third country/territory',
    nationalTaxRefHelp: 'Either the selected country of business or its region',
    validations: {
      BUSINESS_AND_ISSUING_COUNTRIES_NOT_EQUAL: '[Issuing country](lf://./issuingCountry) must be equal either the [Country of Business](lf://./countryOfBusiness) or the [Region/Territory](lf://./cobRegion).',
      COB_REGION_SHOULD_BE_USED: ktI18nFn(({parentA2, regionA2}) => `To use the chosen [Issuing Country](lf://./issuingCountry), the [Country of Business](lf://./countryOfBusiness) and [Region/Territory](lf://./cobRegion) must be respectively changed to ${parentA2} and ${regionA2}.`),
      ISSUER_COUNTRY_NOT_EQUAL_PARENT: '[Issuing country](lf://./issuingCountry) must be equal to the [Country of Business](lf://./countryOfBusiness).',
      ISSUING_COUNTRY_NOT_EQUAL_REGION: '[Issuing country](lf://./issuingCountry) must be equal to the [Region/Territory of Business](lf://./cobRegion).',
      ISSUING_COUNTRY_MS_IS_EU_COUNTRY: 'You can only fill-in a Member State as [Tax Identification Number Issuer](lf://./issuingCountry) when tax numbers associated with that region have that Member State as the issuing country. It must indicate the same value as in [Região](lf://./cobRegion).',
      ISSUER_CODE_NOT_COUNTRY: '[Issuing country](lf://./issuingCountry) must be equal to a country outside the Union.',
    }
  },

  '/?/meetsConditions': {
    label: 'I confirm that I meet the conditions to register for this scheme.'
  },

  '/?/currVatId': {
    netpVat: 'Tax Identification Number ou third country/territory',
    netpHelp: 'Individual VAT identification number allocated by the Member State of identification in accordance with Article 362 of Directive 2006/112/EC',
  },
  '/?/currVatId/vatIdNum': {
    legend: 'Filled-in by the system after approval'
  },

  '/?/notEstablishedInEU': {
    label: 'Not established in EU',
    [I18N_VALUE_CODE_KEY]: '16.1'
  },

  '/?/issuingCountry': {
    label: 'TIN issuing country',
    [I18N_VALUE_CODE_KEY]: '2',
    legend: 'Issuing country code',
  },
  '/?/nationalTaxNumber': {
    label: 'TIN',
    legend: 'TIN in that country'
  },

  '/?/bankAccountInfo': {
    validations: {
      IBAN_OBAN_BOTH_NOT_ALLOWED: 'Cannot have both OBAN and IBAN numbers.'
    }
  },
  '/?/bankAccountInfo/oban': {
    label: 'OBAN (if no IBAN available)',
    [I18N_VALUE_CODE_KEY]: '11',
    validations: {
      OBAN_NOT_ALLOWED: 'This field must be empty.'
    }
  },

  '/?/countryOfBusiness': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Country in which the taxable person has his place of business'
  },

  // Relevant Dates
  '/?/relevantDates/registrationReqDate': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Date of request by the taxable person to be registered under the scheme'
  },

  '/?/prevOrCurrOssVatId': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Individual VAT identification number(s) allocated by the Member State of identification in accordance with Articles 362, 369d or 369q of Directive 2006/112/EC if the taxable person has previously used or is currently using one of these schemes'
  },

  // Consent / Change of MSID
  '/?/registration': {
    label: 'Notices',
  },
};
